import React from 'react';

const BrutalistContainer = ({ className = "" }) => {
  return (
    <div className={`w-full h-full bg-[#dcd9d2] relative overflow-hidden ${className}`}>
      {/* Corrugated Metal Texture */}
      <div 
        className="absolute inset-0 opacity-40"
        style={{
          backgroundImage: `repeating-linear-gradient(
            90deg,
            transparent,
            transparent 2rem,
            rgba(0,0,0,0.08) 2rem,
            rgba(0,0,0,0.08) 2.2rem,
            rgba(255,255,255,0.4) 2.2rem,
            rgba(255,255,255,0.4) 2.4rem
          )`
        }}
      />
      
      {/* Container Frame/Borders */}
      <div className="absolute inset-0 border-[0.8rem] border-[#2a2a2a]" />
      
      {/* Corner Castings */}
      <div className="absolute top-0 left-0 w-8 h-8 bg-[#2a2a2a]" />
      <div className="absolute top-0 right-0 w-8 h-8 bg-[#2a2a2a]" />
      <div className="absolute bottom-0 left-0 w-8 h-8 bg-[#2a2a2a]" />
      <div className="absolute bottom-0 right-0 w-8 h-8 bg-[#2a2a2a]" />
      
      {/* Vertical Locking Rods */}
      <div className="absolute top-4 bottom-4 left-[30%] w-2 bg-[#333] shadow-sm flex flex-col justify-center items-center gap-24">
         <div className="w-3 h-8 bg-[#111] rounded-sm"></div>
         <div className="w-3 h-8 bg-[#111] rounded-sm"></div>
      </div>
      <div className="absolute top-4 bottom-4 right-[30%] w-2 bg-[#333] shadow-sm flex flex-col justify-center items-center gap-24">
         <div className="w-3 h-8 bg-[#111] rounded-sm"></div>
         <div className="w-3 h-8 bg-[#111] rounded-sm"></div>
      </div>
      
      {/* Center Line (Door Gap) */}
      <div className="absolute inset-y-0 left-1/2 w-0.5 bg-black/20"></div>

    </div>
  );
};

export default BrutalistContainer;
